<template>
  <div class="icon-text-card">
    <icono
      class="icon-text-card__icon" 
      :icon="icono" 
      :size="90"
      :style="{color: color}"></icono>
    <h4 class="icon-text-card__title">
      {{ titulo }}
    </h4>
    <p class="icon-text-card__text">
      {{ texto }}
    </p>
  </div>
</template>

<script>

  export default {
    name: 'VIconTextCard',
    props: {
      color: String,
      icono: String,
      titulo: String,
      texto: String
    }
  }
</script>

<style lang="scss" scoped>
  .icon-text-card {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: $color-white;
    padding: 10px;
    margin: 10px;
    box-shadow: 1px 1px 2px 0px rgba(128,126,128,0.56);
    &__title {
      font-family: $ff-2;
      text-align: center;
      font-size: 14px;
      color: $color-1;
      height: 45px;
      overflow: hidden;
      @include desde($extra-large) {
        font-size: 18px;
      }
    }
    &__text {
      font-family: $ff-2;
      font-size: 12px;
      text-align: center;
      height: 80px;
      overflow: hidden;
      @include desde($large) {
        font-size: 16px;
        height: 95px;
      }
    }
  }
</style>